import React from 'react';
import TablaClaseProc from '../components/impuestoprodu/tablaClaseProc';

function ClassProduc() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaClaseProc />
      </div>
  );
}

export default ClassProduc;




// WEBPACK FOOTER //
// ./src/pages/claseproduc.js